@if (!isProducer && (formattedProspectArray?.length > 0)) {
  <div class="applicationStatus mat-typography mat-body mat-app-background"
    >
    <h1>MARKETPLACE APPLICATION STATUS</h1>
    <hr />
    @if (formattedProspectArray.length > 0) {
      @for (prospect of formattedProspectArray; track prospect) {
        <div>
          <div class="results-container">
            <div class="customer-data">
              <!-- Name + Date + Status -->
              <div class="row margin-top">
                <div>
                  <h3>{{prospect.firstName}} {{prospect.lastName}}</h3>
                  <span class="silver-text">{{prospect.dataForTemplate.statusDetails.description}}</span>
                </div>
                <div class="align-right">
                  <span class="silver-text">Date of Last Activity:</span>
                  <span>{{prospect.dataForTemplate.formattedTime}}</span>
                </div>
              </div>
              <!-- ZIP + County -->
              <div class="row margin-top">
                <div>
                  <span class="silver-text">Coverage Zip Code</span>
                  <span>{{prospect.shoppingInfo.zipCode}}</span>
                </div>
                <div class="align-right">
                  @if (prospect.shoppingInfo.county) {
                    <span class="silver-text">County</span>
                    <span>{{prospect.shoppingInfo.county}}</span>
                  }
                </div>
              </div>
              <!-- Status Info -->
              <div class="row margin-top">
                <div>
                  <span class="silver-text">
                    Status Details
                  </span>
                  <div class="reset" [innerHTML]="prospect.dataForTemplate.statusDetails.details">
                  </div>
                </div>
                <div>
                  <!-- placeholder -->
                </div>
              </div>
            </div>
            <hr class="margin-top" />
            <!-- Buttons -->
            <div class="button-container">
              @if (prospect.dataForTemplate.isApprovedForSale) {
                <div class="row">
                  @if (prospect.dataForTemplate.statusDetails.buttons.shopHighmark) {
                    <div>
                      <button mat-raised-button color="primary" (click)="buttonActions(prospect).shopHighmark()">
                        Shop Directly with Highmark
                      </button>
                    </div>
                  }
                  @if (prospect.dataForTemplate.statusDetails.buttons.continueToMarketplace) {
                    <div>
                      <button mat-raised-button color="primary" (click)="buttonActions(prospect).continueToMarketplace()">
                        Continue to the Marketplace
                      </button>
                    </div>
                  }
                  @if (prospect.dataForTemplate.statusDetails.buttons.printSummary) {
                    <div>
                      <button mat-raised-button color="primary" (click)="buttonActions(prospect).printSummary()">
                        Print
                      </button>
                    </div>
                  }
                  @if (prospect.dataForTemplate.statusDetails.buttons.makePayment) {
                    <div>
                      @if (eBillOn) {
                        <sxe-sso-handler
                          [arguments]="prospect"
                          link-type="sso-button"
                          sso-type="ebill"
                          sso-label="Make Payment"
                        ></sxe-sso-handler>
                      }
                      @if (!eBillOn) {
                        <button mat-raised-button color="primary"
                          (click)="buttonActions(prospect).makePayment()">
                          Make Payment
                        </button>
                      }
                    </div>
                  }
                  @if (prospect.dataForTemplate.statusDetails.buttons.goToMarketplace) {
                    <div>
                      <button mat-raised-button color="primary" (click)="buttonActions(prospect).goToMarketplace()">
                        Go to Marketplace
                      </button>
                    </div>
                  }
                  @if (prospect.dataForTemplate.statusDetails.buttons.goToHealthSherpa) {
                    <div>
                      <button mat-raised-button color="primary" (click)="buttonActions(prospect).goToHealthSherpa()">
                        Go To Health Sherpa
                      </button>
                    </div>
                  }
                  @if (prospect.dataForTemplate.statusDetails.buttons.viewResults) {
                    <div>
                      <button mat-raised-button color="primary" (click)="buttonActions(prospect).viewResults()">
                        View Results
                      </button>
                    </div>
                  }
                  @if (prospect.dataForTemplate.statusDetails.buttons.moreInfo) {
                    <div>
                      <button mat-raised-button color="primary" (click)="buttonActions(prospect).moreInfo()">
                        More Info
                      </button>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
    } @else {
      <div class="spinner-container">
        <mat-spinner [diameter]="100"></mat-spinner>
      </div>
    }
  </div>
} @else {
  @if (isProducer && !showLoadingIndicator) {
    <div class="margin-top">
      @if (isBeginNewProspectFlow) {
        <!-- NEW QUOTE-->
        <app-new-quote-on-exchange [selectedMarket]="selectedMarket" (cancel)="endNewProspect()">
        </app-new-quote-on-exchange>
      } @else {
        <!-- TOGGLE BUTTONS + NEW QUOTE BUTTON -->
        <div class="button-container">
          <mat-button-toggle-group [(ngModel)]="applicationStatus" [value]="applicationStatus"
            aria-label="Select Application Types">
            @for (config of applicationStatuses; track config; let last = $last) {
              <mat-button-toggle
              (click)="switchResponseStatus(config.status)">{{config.displayContent}}</mat-button-toggle>
            }
          </mat-button-toggle-group>
          <!-- This button toggles the 2 below experiences -->
          <button mat-raised-button color="primary" (click)="beginNewProspectFlow()">
            Create a New Prospect
          </button>
        </div>
        <!-- PROSPECT APP RESULTS -->
        @if (onExchangeProspects?.length > 0 && displayOnx) {
          @for (prospect of onExchangeProspects | producerProspectPaginator; track trackByIndex($index, prospect)) {
            <app-application-card-on-exchange
              [prospect]="prospect" (viewResults)="buttonActions({ prospectId: $event }).viewResults()"
              (makePayment)="buttonActions({ prospectId: $event }).makePayment()"
              (moreInfo)="buttonActions().moreInfo($event)" (expire)="buttonActions({ prospectId: $event }).expire()">
            </app-application-card-on-exchange>
          }
        }
        <app-producer-prospect-paginator></app-producer-prospect-paginator>
      }
    </div>
  } @else {
    <div class="spinner-container">
      <mat-spinner [diameter]="100"></mat-spinner>
    </div>
  }
}

